import * as React from 'react';
import PropTypes from 'prop-types';
import {Link} from 'react-router-dom';
import * as routes from '../../../util/routes';
import {List, ListItem} from '../../list';

export default class LocalAuthorityListComponent extends React.Component {
	render() {
		const localAuthorities = this.props.localAuthorities;
		return (
			<div>
				<p><Link to={routes.LOCAL_AUTHORITIES_ADD}>Ajouter une collectivité</Link></p>

				<List loading={this.props.loading} loadingText="Chargement des collectivités...">
					{localAuthorities && localAuthorities.map(la => (
						<ListItem
						id={'la-' + la.slug}
						key={la.id} 
						primaryText={la.name}
						route={`${routes.LOCAL_AUTHORITIES}/${la.slug}`}
						secondaryText={la.code} />
					))}
				</List>
			</div>
		);
	}
}

LocalAuthorityListComponent.propTypes = {
	loading: PropTypes.bool.isRequired,
	localAuthorities: PropTypes.array
};


// WEBPACK FOOTER //
// ./src/component/local-authority/local-authority-list/local-authority-list-component.js